// extracted by mini-css-extract-plugin
export default {"row":"styles_row__2t8Fc","deleteBtn":"styles_deleteBtn__HU61d"};